import {
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    PRODUCTS,
    SALESORDERS,
    TASKS,
} from 'constants/Entities';

export const ENTITIES_WHITELIST = [
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    PRODUCTS,
    SALESORDERS,
    TASKS,
];
export const FILTERS_CACHE_KEY = 'filters_store_v1';
